import React, {useEffect, useState} from 'react'

import {Link} from 'react-router-dom'

import dssd from '../../../../../src/assets/list/empty.webp'

import './Transfer.css'
import {AiOutlineCloseCircle} from 'react-icons/ai'
import {MDBTable, MDBTableBody, MDBTableHead} from 'mdb-react-ui-kit'
import {AppContainer} from '../../../../_metronic/helpers/components/AppContainer'
import PrivateRequest from '../../api/PrivateRequest'
import {digitSeparator} from '../../../../_metronic/helpers/digit-separator'
import Skeleton from 'react-loading-skeleton'

const TransferListRequest = () => {
  const [list, setList] = useState<any>()
  const [isLoading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    PrivateRequest()
      .get('/club/stock-transfer-list')
      .then((res) => {
        console.log('request_list', res)
        setLoading(false)
        setList(res.data.request_list)
        console.log('mylist', res.data.request_list)
      })
      .catch((err) => {
        setLoading(false)
        console.log('err', err)
      })
  }, [])

  return (
    <AppContainer title={'لیست درخواست های انتقال'}>
      {isLoading && <Skeleton height={100} />}
      {list && list.length > 0 ? (
        <div>
          <div className='table-responsive'>
            <MDBTable dir={'rtl'} className='table sm:gs-7 sm:gy-7 sm:gx-7  border'>
              <MDBTableHead>
                <tr className=' border text-center'>
                  <th className='thHome'> موضوع درخواست</th>
                  <th className='thHome'>دپارتمان</th>
                  <th className='thHome'>کد سهام</th>
                  <th className='thHome'>کد پیگیری</th>
                  <th className='thHome'>نوبت فروش </th>
                  <th className='thHome'>قیمت فروش </th>
                  <th className='thHome'>وضعیت </th>
                </tr>
              </MDBTableHead>
              {list &&
                list.map((list: any, index: number) => {
                  return (
                    <MDBTableBody className=' border border-top'>
                      <tr className=' border border-bottom text-center' key={list.id}>
                        <td>انتقال سهام</td>
                        <td>سهام</td>
                        <td>{list.stock_id}</td>
                        <td>{list.rrn}</td>
                        <td>{list.queue_number}</td>
                        <td>{digitSeparator(list.price)}</td>
                        <td>
                          <Link to={`/stock/transfer-request-detail/${list.id}`}>
                            <button className='bg-green-400 text-white border-0 rounded-md py-1 px-2'>
                              <AiOutlineCloseCircle />
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </MDBTableBody>
                  )
                })}
            </MDBTable>
          </div>
        </div>
      ) : (
        // <ListTable list={list}  />
        <>
          {!isLoading && (
            <div>
              <div className=''>
                <div className=''>
                  <img width={650} src={dssd} />
                </div>
                <div className='btnNewRequest lg:-mt-12 '>
                  <Link to='/request'>
                    <button
                      type='submit'
                      className=' text-2xl font-extrabold btnNewRequest	 text-white 	'
                    >
                      ثبت درخواست جدید
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </AppContainer>
  )
}

export default TransferListRequest
